<script>
import Splash from "@/components/Splash/Splash.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import Labor from "@/components/Financial_management_and_productivity/FunctionalInformation/Labor";

export default {
  components: {Sidebar, Splash, Labor}
}
</script>

<template>
  <splash/>
  <div class="container mt-4" dir="rtl">
    <sidebar/>
    <div class="card-panel-main col-lg-9 mb-5 p-4">

      <div class="card bg-white">
        <div class="d-flex m-3 justify-content-between border-bottom border-2">
          <p class="fw-bold">
            نیروی کار
          </p>
        </div>

        <Labor/>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card-panel-main {
  transform: translateX(-19vw);
}
</style>
